import { useTranslation } from "react-i18next";

import { FCC } from "@/types";

export const DunningProcessOpenSection: FCC = () => {
  const { t } = useTranslation();

  return (
    <div className="block xl:ml-[38px] xl:w-[300px]">
      <div className="flex flex-col xl:flex-row">
        <div className="min-h-[2px] w-[200px] bg-primary-100 xl:ml-auto xl:mr-10 xl:min-h-full xl:w-[2px] xl:min-w-[2px]" />
        <div>
          <h3 className="mb-4 mt-6 text-error-100 xl:mt-0">
            {t(
              "translation:Onboarding.sections.sim-selection.dunningProcessOpenTitle",
            )}
          </h3>

          <p className="font-regular mb-10 block text-black">
            {t(
              "translation:Onboarding.sections.sim-selection.dunningProcessOpenText",
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
